import { Box, Button, Divider, IconButton, Modal, Typography } from "@mui/material";
import React from "react";
import CloseIcon from '@mui/icons-material/Close';

import AppIcon from "../assets/app-inv-ico.svg";
import DashIcon from "../assets/dash-ico.svg";
import ChatIcon from "../assets/chat-ico.svg";

const InfoMain = () => {
    const [isOpen, setIsOpen] = React.useState<boolean>(true);
    const modalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '840px',
        outerHeight: '600px',
        innerHeight: '600px',
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        p: 4,
    };
    const closeInfo = async (url: string) => {
        setIsOpen(false);
        if (url != '/') {
            location.href = url;
        }
    };

    const openInNewTabAndClose = (url: string) => {
        setIsOpen(false);
        window.open(url, '_blank').focus();
    };

    return (
        <Modal
            open={isOpen}
            onClose={() => closeInfo('/')}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description">
            <Box sx={modalStyle}>
                <IconButton
                    aria-label="close"
                    onClick={() => closeInfo('/')}
                    sx={(theme) => ({
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: theme.palette.grey[500],
                    })}
                >
                    <CloseIcon />
                </IconButton>
                    <div>
                    <div className="details-apps-header">Welcome to the IDaaS Migration Portal</div>
                        <br />
                        <Divider></Divider>
                    <br />
                    <Typography className="details-apps-subheader">What does it offer?</Typography>
                    <br />
                    <div className="details-apps-widget" onClick={() => closeInfo('/')}>
                        <p>
                            <br />
                            <img src={AppIcon} className="details-apps-widget-img"></img><br /><br/>
                            <b>Application Inventory</b><br /><br />
                            Showcases the status of the applications you are the owner of, the metadata, application readiness and further instructions to migrate your applications to EntraID.
                        </p>
                    </div>
                    <div className="details-apps-widget" onClick={() => closeInfo('/dashboards')} >
                        <p>
                            <br />
                            <img src={DashIcon} className="details-apps-widget-img"></img><br /><br />
                            <b>Dashboard</b><br /><br />
                            Presents a comprehensive overview of all the applications in the migration. Allows to monitor progress and to make informed decisions.
                        </p>
                    </div>
                    <div className="details-apps-widget" onClick={() => closeInfo('/assistant') } >
                        <p>
                            <br />
                            <img src={ChatIcon} className="details-apps-widget-img"></img><br /><br />
                            <b>Chat Assistant</b><br /><br />
                            Provides instant assistance, offers interactive support and guidance, answers queries related to the migration process.
                        </p>
                    </div>
                    <br/>
                    <br />
                    <Button style={{ margin: '10px', float: 'right', width: '100px', textTransform: 'none', backgroundColor: '#FD5107' }} variant="contained" color="success" onClick={() => closeInfo('/')}>Close</Button>
                    <Button style={{ margin: '10px', float: 'left', width: '180px', textTransform: 'none', backgroundColor: 'white', color: '#FD5107', borderColor: '#FD5107', borderStyle: 'solid', borderWidth: '10' }} variant="outlined" color="warning" onClick={() => openInNewTabAndClose('https://migration.idaas.pwc.com/')}>Further Documentation</Button>
                    </div>
                <br />
            </Box>
        </Modal>
    );
};

export default InfoMain;